import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { NAVIGATION_PROP } from '@root/src/hooks/useNavigationHistory';
import { formatDateAsYear } from '@root/src/utils/dates';
import getRoute from '@services/routeList';
import { mediaBreakpoint, RESPONSIVE, useResponsive } from '@services/responsiveProvider';
import EventHeaderBanner from '@features/eventDetail/components/EventHeaderBanner';
import PageTitle from '@features/ui/components/PageTitle';
import EventTabs from '@features/eventDetail/components/EventTabs';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';
import Button, { BUTTON_VARIANT } from '@features/ui/components/Button';
import { ICON_NAME } from '@features/ui/components/Icon';
import { getQueryEventId } from '@features/eventDetail/utils';
import { selectNavigationHistoryUrl } from '@features/ui-layout/slices/uiLayoutSlice';

type EventHeaderProps = {
  className?:string;
};

const EventHeader = ({ className }: EventHeaderProps) => {
  const router = useRouter();
  const event = useSelector(selectEventDetail(getQueryEventId(router.query)));
  const lastNonEventPage = useSelector(selectNavigationHistoryUrl(NAVIGATION_PROP.lastNonEventPage));
  const responsive = useResponsive();
  const { t } = useTranslation();

  const handleBackClick = () => {
    router.push(lastNonEventPage ?? getRoute.events().list({}));
  };

  return (
    <div className={className}>
      <Header>
        <StyledTitle
          title={`${event.name} - ${formatDateAsYear(event.date)}`}
          backFunction={handleBackClick}
        />
        {responsive === RESPONSIVE.DESKTOP && (
          <Button
            text={t('eventHeader_seeAllEventsButton.message')}
            variant={BUTTON_VARIANT.link}
            leftIcon={ICON_NAME.arrowForward}
            url={getRoute.events().list({})}
          />
        )}
      </Header>
      {event.imageCover && <EventHeaderBanner /> }
      <EventTabs />
    </div>
  );
};

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 32px;
`;

const StyledTitle = styled(PageTitle)`
  flex: 1;
  
  ${mediaBreakpoint.tablet} {
    max-width: calc(100% - 130px);
  } 
  ${mediaBreakpoint.mobile} {
    max-width: 100%;
  }
  
`;

export default EventHeader;
